module.exports = __webpack_public_path__ + "static/media/ki.425f5fd0.png";